"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EndPolicyMain = void 0;
var coverage_1 = require("@newfront-insurance/admin-ui/coverage");
var data_layer_client_1 = require("@newfront-insurance/data-layer-client");
var next_notifications_1 = require("@newfront-insurance/next-notifications");
var workflow_1 = require("@newfront-insurance/workflow");
var react_1 = __importDefault(require("react"));
var end_policy_change_1 = require("../../mutations/end-policy-change");
var helpers_1 = require("./lib/helpers");
var types_1 = require("./lib/types");
var machine_1 = require("./machine");
var cancellation_policy_change_1 = __importDefault(require("./steps/cancellation-policy-change"));
var primary_reason_step_1 = __importDefault(require("./steps/primary-reason-step"));
var secondary_reason_step_1 = __importDefault(require("./steps/secondary-reason-step"));
function EndPolicyMain(_a) {
    var billing = _a.billing, policyLegacyId = _a.policyLegacyId, policyUuid = _a.policyUuid, accountUuid = _a.accountUuid, onSubmit = _a.onSubmit;
    var machine = machine_1.useMachine(billing);
    var analytics = data_layer_client_1.useAnalytics();
    var notifications = next_notifications_1.useNotifications();
    var workflow = workflow_1.useWorkflow({
        name: 'endPolicy',
        analyticsClient: analytics,
        machine: machine,
        onComplete: function () { return undefined; },
    });
    var endPolicyAsync = coverage_1.useEndPolicy({
        onSuccess: function () {
            notifications.add({
                type: 'success',
                title: 'Policy Ended successfully',
            });
        },
        onError: function () {
            notifications.add({
                type: 'error',
                title: "There was a problem ending the policy.\n        Please try again and contact bugs@newfront.com if you\u2019re unable to end the policy.",
            });
        },
    }).mutateAsync;
    var endPolicyChange = end_policy_change_1.useHandleEndPolicyChange()[0];
    function handleBack(values) {
        workflow.previousStep(values);
    }
    function handleNext(values) {
        workflow.nextStep(values);
    }
    function handleSubmit(values) {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        data = {
                            primaryCancellationReason: helpers_1.toPrimaryCancellationReason(values.primaryReason),
                            secondaryCancellationReason: helpers_1.toSecondaryCancellationReason(values.secondaryReason),
                            cancellationEffectiveDate: values.effectiveDate,
                        };
                        return [4 /*yield*/, endPolicyAsync({ policyUuid: policyUuid, data: data })];
                    case 1:
                        _a.sent();
                        onSubmit({ accountUuid: accountUuid });
                        return [2 /*return*/];
                }
            });
        });
    }
    function handleChangeSubmit(values) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, premium, stateTax, stateStampingFee, miscTaxesAndFees, carrierPolicyFee, newfrontFee, wholesaleFee, data, endData;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = values.billingChanges, premium = _a.premium, stateTax = _a.stateTax, stateStampingFee = _a.stateStampingFee, miscTaxesAndFees = _a.miscTaxesAndFees, carrierPolicyFee = _a.carrierPolicyFee, newfrontFee = _a.newfrontFee, wholesaleFee = _a.wholesaleFee;
                        data = {
                            carrierPolicyFeeChange: carrierPolicyFee.updated - carrierPolicyFee.current,
                            newfrontFee: newfrontFee.updated - newfrontFee.current,
                            miscTaxesAndFees: miscTaxesAndFees.updated - miscTaxesAndFees.current,
                            premiumChange: premium.updated - premium.current,
                            stateTaxChange: stateTax.updated - stateTax.current,
                            stateStampingFeeChange: stateStampingFee.updated - stateStampingFee.current,
                            wholesaleFeeChange: wholesaleFee.updated - wholesaleFee.current,
                            effectiveDate: values.effectiveDate || '',
                            notesHtml: values.notes || '',
                            status: values.status || '',
                            type: 'cancel',
                        };
                        endData = {
                            primaryCancellationReason: helpers_1.toPrimaryCancellationReason(values.primaryReason),
                            secondaryCancellationReason: helpers_1.toSecondaryCancellationReason(values.secondaryReason),
                            cancellationEffectiveDate: values.effectiveDate,
                        };
                        return [4 /*yield*/, endPolicyChange({ policyLegacyId: policyLegacyId, data: data })];
                    case 1:
                        _b.sent();
                        return [4 /*yield*/, endPolicyAsync({ policyUuid: policyUuid, data: endData })];
                    case 2:
                        _b.sent();
                        onSubmit({ accountUuid: accountUuid });
                        return [2 /*return*/];
                }
            });
        });
    }
    return (react_1.default.createElement(workflow_1.WorkflowProvider, { currentStep: workflow.currentStep },
        react_1.default.createElement(workflow_1.WorkflowContent.Body, null,
            react_1.default.createElement(workflow_1.WorkflowStep, { id: types_1.Steps.PRIMARY_REASON_STEP },
                react_1.default.createElement(primary_reason_step_1.default, { onSubmit: handleNext, context: workflow.context })),
            react_1.default.createElement(workflow_1.WorkflowStep, { id: types_1.Steps.SECONDARY_REASON_STEP },
                react_1.default.createElement(secondary_reason_step_1.default, { context: workflow.context, onSubmit: workflow.context.primaryReason === types_1.PrimaryReason.CUSTOMER_CANCEL ? handleNext : handleSubmit, onBack: handleBack })),
            react_1.default.createElement(workflow_1.WorkflowStep, { id: types_1.Steps.CANCELLATION_POLICY_CHANGE_STEP },
                react_1.default.createElement(cancellation_policy_change_1.default, { context: workflow.context, onSubmit: handleChangeSubmit, onBack: handleBack, initialBillingChanges: workflow.context.initialBillingChanges })))));
}
exports.EndPolicyMain = EndPolicyMain;
